module.exports = __webpack_public_path__ + "img/IMG-20200319-WA0117.a7bbf3be.jpg";